/**
 * @typedef {Object} HeaderTypes
 * @prop {Symbol} independents Independents header type
 * @prop {Symbol} internal Internal sidebar header type
 * @prop {Symbol} investors Investors header type
 * @prop {Symbol} partners Partners header type
 */
/**
 * @const {HeaderTypes} TYPES Header types
 * @public
 */
const TYPES = {
  independents: Symbol('independents'),
  internal: Symbol('internal'),
  investors: Symbol('investors'),
  partners: Symbol('partners')
};

/**
 * @const {{ [typeName: string]: Symbol }} HEADER_TO_TYPE Map between header type names and Symbol types
 * @public
 */
const HEADER_TO_TYPE = {
  'independents-header': TYPES.independents,
  'internal-sidebar': TYPES.internal,
  'investors-header': TYPES.investors,
  'partners-header': TYPES.partners
};

module.exports = {
  TYPES,
  HEADER_TO_TYPE
};
